import { Box, Chip, IconButton, Typography } from '@material-ui/core'
import Close from '@material-ui/icons/Close'
import classNames from 'classnames'

import { Autocomplete } from '@/components/auto-complete'
import { useGetMembers } from '@/hooks/queries/use-get-members'
import User from '@/types/user'

import { useStyles } from './styles'

type UserDTO = Omit<User, 'exp'>

interface MembersAutocompleteProps {
  className?: string
  enabled?: boolean
  selectedMembers: UserDTO[]
  handleSelectedMembers: (members: UserDTO[]) => void
  filterData?: UserDTO[]
}

export const MembersAutocomplete = ({
  className,
  enabled = false,
  selectedMembers,
  handleSelectedMembers,
  filterData,
}: MembersAutocompleteProps) => {
  const classes = useStyles()

  const { data, isFetching, isError } = useGetMembers(enabled)

  const filteredData = data?.filter(
    (member) =>
      !filterData?.some((filterMember) => filterMember.id === member.id),
  )

  return (
    <Autocomplete
      id='members'
      multiple
      limitTags={1}
      className={classNames(classes.autocomplete, className)}
      filterSelectedOptions
      value={selectedMembers as any}
      onChange={(_, newValue) => {
        const users = newValue as UserDTO[]
        handleSelectedMembers(
          users.map((user) => ({
            id: user.id,
            name: user.name,
            email: user.email,
          })),
        )
      }}
      disabled={!enabled}
      options={filteredData || []}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            key={index}
            label={<Typography variant='body1'>{option.email}</Typography>}
            deleteIcon={
              <IconButton size='small'>
                <Close />
              </IconButton>
            }
            {...getTagProps({ index })}
          />
        ))
      }
      getOptionSelected={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option.name}
      renderOption={(option) => (
        <Box className={classes.memberSelected}>
          <Typography noWrap>{option.name}</Typography>
          <Typography noWrap variant='subtitle1'>
            {option.email}
          </Typography>
        </Box>
      )}
      loading={isFetching}
      noOptionsText='Não foi encontrado membros para a companhia atual.'
      inputTextProps={{
        placeholder: 'Adicione pessoas',
        variant: 'filled',
        error: !isFetching && isError,
        helperText:
          !isFetching &&
          isError &&
          'Não foi encontrado membros para a companhia atual.',
        InputProps: {
          disableUnderline: true,
        },
      }}
    />
  )
}
